import React, { useEffect, useState } from 'react';
import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { useSelector } from "react-redux";
import moment from "moment";
import { postFormulaire } from "../../../api/envoiMailService";
import { postChangementContrat } from "../../../api/modificationContratService";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";
import { renderError } from "../../../utils/formUtils";
const CONF = window?.confPub;

export default function DemandeDocument(
    {
        isInside
    }
) {

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        infosCorrespondant,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const TYPE_INDIVIDU = CONF?.TYPE_INDIVIDU
    // TODO utiliser cette liste / voir pour le reste ce qu'il faut mettre en conf
    const CODES_FORMULAIRES = CONF?.CODES?.CODES_FORMULAIRES;
    const CODE_QUALIF = {
        DEMANDE_CARTE_TIER_PAYANT: "CARTE_TP",
        DEMANDE_CERTIFICAT_AFFILIATION: "CERTIF_APP",
        DEMANDE_ATTESTATION_VERSEMENT_COT: "APPEL_DE_C",
        DEMANDE_CERTIFICAT_RADIATION: "CERTIF_RAD",
        DEMANDE_CERTIFICAT_RADIATION_ALL: "CERTIF_RAD_ALL",
        DEMANDE_CERTIFICAT_RADIATION_AD: "CERTIF_RAD_AD",
    }
    const listeBeneficiaireSansMp = contratsBeneficiaires.filter(({typeIndividu}) => typeIndividu!== TYPE_INDIVIDU?.MP?.CODE)

    const [submitted, setSubmitted] = useState(false)
    const [disabledForm, setDisabledForm] = useState(false);
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })
    const [idBeneficiaireSelected, setIdBeneficiaireSelected]= useState(listeBeneficiaireSansMp.length === 1 ? listeBeneficiaireSansMp?.[0]?.idUniqueGrc : {})
    const [documentDemande, setDocumentDemande] = useState()

    // Partie pour l'envoi
    const mapDocument = {
        [CODE_QUALIF?.DEMANDE_CARTE_TIER_PAYANT]: {
            label: "Carte tiers-payant",
            code: CODE_QUALIF?.DEMANDE_CARTE_TIER_PAYANT,
        },
        [CODE_QUALIF?.DEMANDE_CERTIFICAT_AFFILIATION]: {
            label: "Certificat affiliation",
            code: CODE_QUALIF?.DEMANDE_CERTIFICAT_AFFILIATION,
        },
        [CODE_QUALIF?.DEMANDE_ATTESTATION_VERSEMENT_COT]: {
            label: "Attestation versement de cot (année -1)",
            code:CODE_QUALIF?.DEMANDE_ATTESTATION_VERSEMENT_COT,
        },
        [CODE_QUALIF?.DEMANDE_CERTIFICAT_RADIATION_ALL]: {
            label: "Certificat radiation pour tous les bénéficiaires",
            code: CODE_QUALIF?.DEMANDE_CERTIFICAT_RADIATION,
        },
        [CODE_QUALIF?.DEMANDE_CERTIFICAT_RADIATION_AD]: {
            label: "Certificat de radiation pour l'un des ayants droit",
            code: CODE_QUALIF?.DEMANDE_CERTIFICAT_RADIATION,
        },
    }

    const listeDocument = [
        {
            label: "Carte tiers-payant",
            code: CODE_QUALIF?.DEMANDE_CARTE_TIER_PAYANT,
        },
        {
            label: "Certificat d'affiliation à la MNH",
            code: CODE_QUALIF?.DEMANDE_CERTIFICAT_AFFILIATION,
        },
        {
            label: "Attestation de versement des cotisations au titre de l'année précédente",
            code:CODE_QUALIF?.DEMANDE_ATTESTATION_VERSEMENT_COT,
        },
        {
            label: "Certificat de radiation pour l'ensemble des bénéficiaires",
            code: CODE_QUALIF?.DEMANDE_CERTIFICAT_RADIATION_ALL,
        },
        ...(listeBeneficiaireSansMp.length > 0 ? [
            {
                label: "Certificat de radiation pour l'un des ayants droit",
                code: CODE_QUALIF?.DEMANDE_CERTIFICAT_RADIATION_AD,
            }
        ] : [])
    ]

    const handleOptionChangeDocument = (e) => {

        setDocumentDemande(e?.target?.value)
    }

    const handleOptionChange = (e) => {

        setIdBeneficiaireSelected(e?.target?.value)
    }

    const handleSubmit = async (e) => {

        e.preventDefault()
        setDisabledForm(true)

        if (documentDemande) {

            const champ = [];
            const docSelected = mapDocument?.[documentDemande]
            const contratBeneficiaire = contratsBeneficiaires.find(({ idUniqueGrc }) => idUniqueGrc === idBeneficiaireSelected)

            champ.push(
                {
                    label: "Numéro MNH",
                    valeur: detailPersonne?.contrat?.[0]?.numeroContrat
                },
                {
                    label: "Nom MP",
                    valeur: detailPersonne?.nom
                },
                {
                    label: "Prénom MP",
                    valeur: detailPersonne?.prenom
                },
                {
                    label: "Document",
                    valeur: docSelected?.label
                },
                ...(documentDemande === CODE_QUALIF?.DEMANDE_CERTIFICAT_RADIATION_AD ? [
                    {
                        label: "Ayant droit concerné",
                        valeur: `${ contratBeneficiaire?.civilite } ${ contratBeneficiaire?.prenom } ${ contratBeneficiaire?.nom } - ${ TYPE_INDIVIDU?.[contratBeneficiaire?.typeIndividu]?.LABEL } - né(e) le ${ contratBeneficiaire?.dateNaissance }`,
                    }
                ] : [])
            )

            const formToSend = {
                idGrm: keycloakReduce?.decodedToken?.idGrm,
                idGrcDemandeur: infosCorrespondant?.idGrc,
                idGrcBeneficiaire: detailPersonne?.idPersGrc,
                codeDomaine: contrat?.gammeContrat,
                codeQualification: docSelected?.code,
                champ: champ
            }

            console.log("formToSend")
            console.log(formToSend)

            try {

                const resp = await postChangementContrat(formToSend)

                console.log("resp")
                console.log(resp)

                setSendSuccess({
                    isSuccess: true,
                    message: false,
                    display: true,
                })

                erasedInputs(false)

            } catch (err) {
                console.log("err", err);

                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })
                setSubmitted(true)

            } finally {
                setDisabledForm(false);
            }

        } else {
            setDisabledForm(false)
            setSubmitted(true)
        }
    }

    const erasedInputs = (all = false) => {

        setSubmitted(false)

        if (all) {
            setSendSuccess({
                isSuccess: false,
                message: false,
                display: false,
            })
        }
    }

    return (
        <div className="container mt-3">
            { !isInside && <SecondaryNavBar /> }
            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>
                    <div className="card">

                        <form onSubmit={ handleSubmit }>
                            <div className="card-header">
                                <h2>Demande de document</h2>
                            </div>

                            <div className="card-body">

                                <h3>Document demandé :</h3>

                                <div>
                                    { listeDocument?.length > 0 && listeDocument.map(document => (
                                        <div className="form-check" key={ document?.code }>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="document"
                                                value={ document?.code }
                                                checked={ documentDemande === document?.code }
                                                id={ document?.code }
                                                onChange={ handleOptionChangeDocument }
                                            />
                                            <label
                                                className="form-check-label"
                                                htmlFor={ document?.code }>
                                                { document?.label }
                                            </label>
                                        </div>
                                    )) }

                                    { submitted && !documentDemande
                                        && renderError("Vous devez choisir un document.") }
                                </div>

                                { documentDemande === "CERTIF_RAD_AD"  && (
                                    <div className='mt-3'>
                                        <h3>Ayant droit à radier :</h3>

                                        { listeBeneficiaireSansMp?.length > 0 && listeBeneficiaireSansMp.map(contrat => (
                                            <div className="form-check" key={ contrat?.idUniqueGrc }>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="contrat"
                                                    value={ contrat?.idUniqueGrc }
                                                    checked={ idBeneficiaireSelected === contrat?.idUniqueGrc }
                                                    id={ contrat?.idUniqueGrc }
                                                    onChange={ handleOptionChange }
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={ contrat?.idUniqueGrc }>
                                                    { contrat?.civilite } { contrat?.prenom } { contrat?.nom } - { TYPE_INDIVIDU?.[contrat?.typeIndividu]?.LABEL } - né(e) le { contrat?.dateNaissance }
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div className="mt-3">
                                    <small>
                                        Après traitement du formulaire, le document sera expédié à l'adresse postale du
                                        membre participant.
                                    </small>
                                </div>

                                <MessageInfoEnvoi
                                    isSuccess={ sendSuccess?.isSuccess }
                                    message={ sendSuccess?.message }
                                    display={ sendSuccess?.display }
                                />
                            </div>

                            <div className="card-footer">
                                <div className='d-flex justify-content-end'>
                                    <button
                                        type='submit'
                                        className="btn btn-primary"
                                        // disabled={ !documentDemande }
                                    >
                                        Envoyer
                                    </button>
                                    <button
                                        type='button'
                                        onClick={ ()  => erasedInputs(true)}
                                        className="btn btn-secondary ms-2"
                                    >
                                        Effacer
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}